import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';
import { LIST_BINS, LIST_BINS_SUCCESS, LIST_BINS_ERROR } from '../../actionType.js';
import apiCall from '../../apiCall.js';
import { Constant } from '../../../../Containers/Helpers/constant.js';
import cogoToast from 'cogo-toast';

function* getBinsList({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/global-bins`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
        'X-Requested-By': 'one-admin',
      },
      params: {
        ...payload?.urlParam,
        pageSize: payload?.urlParam?.pageSize ? payload?.urlParam?.pageSize : Constant?.TABLE_PAGE_SIZE,
      },
    });

    if (response.status === 200) {
      yield put({
        type: LIST_BINS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: LIST_BINS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: LIST_BINS_ERROR, payload: error });
  }
}

export function* watchBinsList() {
  yield takeEvery(LIST_BINS, getBinsList);
}

function* binsListSaga() {
  yield all([fork(watchBinsList)]);
}

export default binsListSaga;
